// Shared factory for PLACEHOLDER routes. One lazy-loaded component (see
// placeholder-page.tsx) reused across every not-yet-ported page, so the
// three group registration files (core.tsx / agents.tsx / admin.tsx) stay
// one line per route.
//
// CONVENTION: when porting a real page, stop calling `placeholderRoute(...)`
// for that path — replace the call site with a direct `createRoute({...,
// component: lazy(() => import('@/app/<path>/page')) })`, same as
// routes/index.tsx / routes/chat.$sessionId.tsx do for the two real routes.
import { lazy } from 'react';
import { createRoute, type AnyRoute } from '@tanstack/react-router';

const LazyPlaceholder = lazy(() => import('./placeholder-page'));

export function placeholderRoute<TParent extends AnyRoute, TPath extends string>(
  getParentRoute: () => TParent,
  path: TPath,
) {
  return createRoute({
    getParentRoute,
    path,
    component: LazyPlaceholder,
  });
}
